const isConsoleAvailable = () => typeof console === 'object' && typeof console.log === 'function'

export function logError (error) {
  if (isConsoleAvailable()) {
    console.error(error)
  }
}



// WEBPACK FOOTER //
// ./src/shared/logError.js